import "../../styles/index.css"
import ContactForm from "./ContactForm";

const ContactMe = () => {
    return ( 
        <div className="ContactMe page" id="contact-me">
            <br />
            <h2>Contact Me</h2>
            <br/>
            <ContactForm/>
        </div>
     );
}
 
export default ContactMe;